<template>
  <div class="wrapper">
    <!-- 查询条件 -->
    <el-row :gutter="5">
      <el-col :xs="4" :sm="4" :md="4" :lg="3" :xl="3">
        <el-select v-model="CustomerId" placeholder="客户" clearable filterable>
          <el-option
            v-for="customer in customers"
            :key="customer.Id"
            :label="customer.Desc"
            :value="customer.Id"
            >{{ customer.Desc }}</el-option
          >
        </el-select>
      </el-col>
      <el-col :xs="4" :sm="4" :md="4" :lg="3" :xl="3">
        <el-date-picker
          v-model="StartDate"
          type="date"
          style="width: 100%"
          placeholder="发货日期从"
          width="80px"
        ></el-date-picker>
      </el-col>
      <el-col :xs="4" :sm="4" :md="4" :lg="3" :xl="3">
        <el-date-picker
          v-model="EndDate"
          type="date"
          style="width: 100%"
          placeholder="发货日期到"
        ></el-date-picker>
      </el-col>
      <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
        <el-button
          type="primary"
          @click="handlesearch"
          style="width:100%;"
          icon="el-icon-search"
          >查询</el-button
        >
      </el-col>
      <!-- <el-col :xs="4" :sm="4" :md="4" :lg="10" :xl="10">
                &nbsp;
            </el-col> -->
      <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
        <el-button type="primary" @click="Load7Days" style="width:100%;"
          >7天</el-button
        >
      </el-col>
      <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
        <el-button type="primary" @click="Load30Days" style="width:100%;"
          >30天</el-button
        >
      </el-col>
      <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
        <el-button type="primary" @click="Load90Days" style="width:100%;"
          >90天</el-button
        >
      </el-col>
      <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
        <el-button type="primary" @click="DownloadImage" style="width:100%;"
          >生成图片</el-button
        >
      </el-col>
    </el-row>
    <el-row>
      <div>
        <span
          >{{ ExpRemark }}</span
        >
      </div>
    </el-row>
    <el-row>
      <div
        ref="canvas"
        style="padding: 20px;width: 75%;background-color: #E5E9F2;"
        v-loading="loading"
      >
        <!-- Card Info -->
        <el-row :gutter="40">
          <el-col :span="24">
            <el-card style="padding: 20px;" class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-size: 28px; margin-right: 20px;">{{
                  CustomerName
                }}</span>
                {{ StartDate.Format("yyyy-MM-dd") }} ~
                {{ EndDate.Format("yyyy-MM-dd") }}
              </div>
              <el-row :gutter="40">
                <el-col :span="5">
                  <div
                    style="display: flex;flex-direction: column;text-align: center;"
                  >
                    <span
                      style="font-size: 22px;color: #dd3229;font-weight: 600;"
                      >{{ TotalCount }}</span
                    >
                    <span style="color: #666;margin-top: 10px;">总件数</span>
                  </div>
                </el-col>
                <el-col :span="7">
                  <div
                    style="display: flex;flex-direction: column;text-align: center;"
                  >
                    <span
                      style="font-size: 22px;color: #dd3229;font-weight: 600;"
                      >{{ TotalCW }}</span
                    >
                    <span style="color: #666;margin-top: 10px;"
                      >总体积 / 重量</span
                    >
                  </div>
                </el-col>
                <el-col :span="6">
                  <div
                    style="display: flex;flex-direction: column;text-align: center;"
                  >
                    <span
                      style="font-size: 22px;color: #dd3229;font-weight: 600;"
                      >100%</span
                    >
                    <span style="color: #666;margin-top: 10px;"
                      >入仓及时率</span
                    >
                  </div>
                </el-col>
                <el-col :span="6">
                  <div
                    style="display: flex;flex-direction: column;text-align: center;"
                  >
                    <span
                      style="font-size: 22px;color: #dd3229;font-weight: 600;"
                      >{{ TotalPercent }}%</span
                    >
                    <span style="color: #666;margin-top: 10px;"
                      >完好入仓率</span
                    >
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <!-- 进度条 -->
        <el-card>
          <div slot="header" class="clearfix">
            <span style="font-weight: 600; font-size: 18px;">入仓任务监控</span>
          </div>
          <el-row :gutter="10">
            <el-col :span="2" style="font-weight: 600;"
              >仓库 <i class="el-icon-s-home"></i
            ></el-col>
            <el-col :span="2" style="font-weight: 600;">详情</el-col>
            <el-col :span="11" style="font-weight: 600;">入仓进度条</el-col>

            <el-col :span="3" style="font-weight: 600;text-align: center;"
              >异常件数</el-col
            >
            <el-col :span="3" style="font-weight: 600;text-align: center;"
              >总件数</el-col
            >
            <el-col :span="3" style="font-weight: 600;text-align: center;"
              >异常百分比</el-col
            >
          </el-row>
          <div v-for="item in WHSummaryList">
            <el-row
              style="margin-bottom: 10px; border-top: dashed #c5c7cc 1px;padding-top: 10px;"
            >
              <el-col :span="2" style="font-weight: 600;"
                >{{ item.WareHouse }}：</el-col
              >
              <el-col :span="2"
                >{{ item.Record_Count_Received }}/{{
                  item.Record_Count
                }}</el-col
              >
              <el-col :span="11"
                ><el-progress
                  :percentage="item.percentage_Rate"
                  :stroke-width="10"
                  style="width: 90%;"
                  :color="customColorMethod(item.percentage_Rate)"
                  :status="customStatus(item.percentage_Rate)"
                ></el-progress
              ></el-col>
              <el-col :span="3" style="text-align: center;">{{
                item.Total_Count_Diff
              }}</el-col>
              <el-col :span="3" style="text-align: center;">{{
                item.Total_Count
              }}</el-col>
              <el-col :span="3" style="text-align: center;"
                >{{ item.percentage_Exp }} %</el-col
              >
              <!-- <el-col :span="8"><el-progress :stroke-width="10"  :percentage="item.percentage_Exp" :format="format" style="width: 80%;" :color="customColorMethod(item.percentage_Exp)"></el-progress></el-col>
                        <el-col :span="2">{{ item.Total_Count_Diff }}/{{ item.Total_Count }}</el-col> -->
            </el-row>
          </div>
        </el-card>
      </div>
    </el-row>
  </div>
</template>

<script>
import WHSummaryJS from "./WHSummary.js";
export default WHSummaryJS;
</script>
<style scoped>
.el-row {
  margin-bottom: 10px;
}

.small-box {
  border-radius: 2px;
  position: relative;
  display: block;
  margin-bottom: 20px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  color: #fff;
}
.small-box > .inner {
  padding: 10px;
}

.small-box h3,
.small-box p {
  z-index: 5;
}
.small-box h3 {
  font-size: 38px;
  font-weight: bold;
  margin: 0 0 10px 0;
  white-space: nowrap;
  padding: 0;
}

.small-box p {
  font-size: 15px;
  margin: 0 0 10px;
}

.small-box .icon {
  -webkit-transition: all 0.3s linear;
  -o-transition: all 0.3s linear;
  transition: all 0.3s linear;
  position: absolute;
  top: -10px;
  right: 10px;
  z-index: 0;
  font-size: 90px;
  color: rgba(0, 0, 0, 0.15);
}

.small-box > .small-box-footer {
  position: relative;
  text-align: center;
  padding: 3px 0;
  color: #fff;
  color: rgba(255, 255, 255, 0.8);
  display: block;
  z-index: 10;
  background: rgba(0, 0, 0, 0.1);
  text-decoration: none;
}

.bluecolor {
  background-color: #64b0f2;
}
.totalInfo {
  /* background-color: #6fb3e0; */
  color: #ffffff;
  height: 120px;

  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0, #3c8dbc),
    color-stop(1, #67a8ce)
  ) !important;
}

.greencolor {
  background-color: #f1b53d !important;
}

.yellowcolor {
  background-color: #3db9dc;
}

.orangecolor {
  background-color: #ff5d48;
}

.bg-yellow {
  background-color: #f39c12 !important;
  color: #fff !important;
}

.bg-green {
  background-color: #00a65a !important;
  color: #fff !important;
}
.info-box {
  display: block;
  min-height: 90px;
  background: #fff;
  width: 100%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-bottom: 8px;
}

.bg-aqua {
  background-color: #00c0ef !important;
  color: #fff !important;
}

.info-box-icon {
  border-top-left-radius: 2px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 2px;
  display: block;
  float: left;
  height: 90px;
  width: 90px;
  text-align: center;
  font-size: 45px;
  line-height: 90px;
  background: rgba(0, 0, 0, 0.2);
}

.info-box-content {
  padding: 10px 0px 10px 10px;
  margin-left: 90px;
}

.info-box-text {
  text-transform: uppercase;
  display: block;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-box-number {
  display: block;
  font-weight: bold;
  font-size: 24px;
  margin-top: 10px;
}

.el-progress__text {
  font-size: 12px !important;
}

.el-progress-bar {
  padding-right: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/WHSummary/WHSummary.vue